import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { CarePlanTemplatesApi } from '../../../apis/CarePlanTemplatesApi/CarePlanTemplatesApi.ts';

export function useGetCarePlanTemplates(
  facilityId?: number | null,
) {
  return useQuery({
    queryKey: [QueryKeys.carePlanTemplates, facilityId ?? 'all'],
    queryFn: () => CarePlanTemplatesApi.getAll(facilityId),
  });
}
